export const nl = {
    nav: {
        home: 'Home',
        about: 'Over mij',
        experience: 'Ervaring',
        projects: 'Projecten',
        skills: 'Vaardigheden',
        contact: 'Contact',
        game: 'Game'
    },
    hero: {
        greeting: 'Hoi, ik ben Koen',
        headline: 'Embedded Software Engineer & Technische Informatica Student',
        description: 'Ik hou van het oplossen van ingewikkelde problemen binnen de embedded wereld en leer graag over nieuwe technieken om efficiënte hardware en software te koppelen.',
        download_cv: 'Download CV',
        contact: 'Contact Opnemen'
    },
    about: {
        title: 'Over Mij',
        intro: 'Vierdejaars student Technische Informatica (HvA) met een sterke interesse in embedded systems. Ik heb ruime ervaring met Raspberry Pi, ESP32 en Arduino, gecombineerd met full-stack development kennis (Java, React, Tailwind). Daarnaast bouw ik graag mijn eigen PCBs in Fusion360.',
        skills: [
            'Ervaren in C++, C en Java',
            'Zelfstandig in PCB-ontwerp (Fusion360)',
            'Gepassioneerd door IoT en slimme hardware-oplossingen'
        ],
        outro: 'Daarnaast vind ik het leuk om met nieuwe technologieën bezig te zijn.'
    },
    experience: { title: 'Ervaring', educationTitle: 'Opleiding' },
    projects: {
        title: 'Projecten',
        viewGithub: 'Bekijk op GitHub',
        viewLive: 'Bekijk Live'
    },
    skills: { title: 'Vaardigheden' },
    contact: {
        title: 'Contact',
        getInTouch: 'Kom in Contact',
        description: 'Heb je een vraag of wil je samenwerken? Stuur me een bericht of mail me direct.',
        email: 'E-mail',
        linkedin: 'LinkedIn',
        phone: 'Telefoon',
        github: 'GitHub',
        form: {
            name: 'Naam',
            email: 'E-mail',
            message: 'Bericht',
            send: 'Verstuur Bericht'
        }
    },
    footer: {
        copyright: (year) => `\u00A9 ${year} Koen Lammers. Alle rechten voorbehouden.`,
        top: 'Terug naar boven',
        freelance: 'Werkzaam als freelancer onder alias Protoneering'
    }
};
